import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@fiverr/fit';
import Tooltip from '../../tooltip';
import { getScoreText, getRatingsCount } from '../../../utils';
import './style.scss';

const RatingTooltip = ({ score, ratingsCount, recentScore, recentRatingsCount }) => (
    <Tooltip className="rating-tooltip">
        <p>{i18n.t('rating.reviews_by_period')}</p>
        <ul>
            <li>
                {i18n.t('rating.last_60_days_score')}
                <span>
                    <SvgIcon icon="full_star" color="yellow" width={12} height={12}/>
                    <strong>{getScoreText(recentScore)}</strong> ({getRatingsCount(recentRatingsCount)})
                </span>
            </li>
            <li>
                {i18n.t('rating.lifetime_score')}
                <span>
                    <SvgIcon icon="full_star" color="yellow" width={12} height={12}/>
                    <strong>{getScoreText(score)}</strong> ({getRatingsCount(ratingsCount)})
                </span>
            </li>
        </ul>
    </Tooltip>
);

RatingTooltip.propTypes = {
    score: PropTypes.number,
    ratingsCount: PropTypes.number,
    recentScore: PropTypes.number,
    recentRatingsCount: PropTypes.number
};

export default RatingTooltip;



// WEBPACK FOOTER //
// ./src/shared/rating/rating_tooltip/index.js